import { captureMessage } from '@sentry/react';
import { useEffect, useState } from 'react';

import { isServer } from 'src/shared/helpers/environment';

export const useReactNativeWebView = (): [
  boolean,
  (message: string) => void,
] => {
  const [isWebView, setIsWebView] = useState<boolean>(false);

  useEffect(() => {
    if (isWebView) return undefined;

    setIsWebView(!isServer() && !!window.ReactNativeWebView);
    return undefined;
  }, [isWebView]);

  const sendReactNativeMessage = (message: string) => {
    if (isWebView) {
      if (window.ReactNativeWebView?.postMessage) {
        window.ReactNativeWebView.postMessage(message);
      } else {
        captureMessage('ReactNativeWebView: missing postMessage');
      }
    }
  };

  return [isWebView, sendReactNativeMessage];
};
